const Error = () => {
  return (
    <svg width='18' height='15' viewBox='0 0 18 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M8.12342 5.83372H9.8766V9.99943H8.12342V5.83372Z' fill='#E7352B' />
      <path
        d='M9.00001 10.8326C8.51588 10.8326 8.12342 11.2056 8.12342 11.6657C8.12342 12.1258 8.51588 12.4989 9.00001 12.4989C9.48414 12.4989 9.8766 12.1258 9.8766 11.6657C9.8766 11.2056 9.48414 10.8326 9.00001 10.8326Z'
        fill='#E7352B'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.877903 15C0.202637 15 -0.219056 14.3049 0.119277 13.7494L8.24138 0.415709C8.57901 -0.138568 9.42099 -0.13857 9.75862 0.415706L17.8807 13.7494C18.2191 14.3049 17.7974 15 17.1221 15H0.877903ZM15.6017 13.3337L9 2.49598L2.3983 13.3337H15.6017Z'
        fill='#E7352B'
      />
      <path d='M8.12342 10.8326H9.8766V12.4989H8.12342V10.8326Z' fill='#E7352B' />
    </svg>
  )
}

export default Error
